module.exports = __webpack_public_path__ + "img/17_6.919c0a72.png";